import axios from '@/plugins/axios';

export const fetchThemes = async (): Promise<any> => new Promise((resolve, reject) => {
  axios.get('widget/themes').then((result) => {
    resolve(result.data.data);
  }).catch((e) => {
    reject(e.response.data);
  });
});
